import { render, staticRenderFns } from "./DocumentCardClassifiers.vue?vue&type=template&id=205a2f44&"
import script from "./DocumentCardClassifiers.vue?vue&type=script&lang=js&"
export * from "./DocumentCardClassifiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports